import { render } from "./bar.vue?vue&type=template&id=27d7731d&scoped=true"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"

import "./bar.vue?vue&type=style&index=0&id=27d7731d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d7731d"]])

export default __exports__